// eslint-disable-next-line no-restricted-imports
import {
  Query_ClientController_GetById_Gender as GenderApi1,
  Query_LegalClientRepresentativeController_GetSnapshot_Value_Gender as GenderApi2,
  Query_LegalClientRepresentativeController_GetById_Gender as GenderApi3,
  Query_ClientController_GetList_AllOf_1_List_Items_Representative_Gender as GenderApi4,
  Query_ClientController_GetById_Representative_Gender as GenderApi5,
} from 'api/generated/graphql';
import { ClientGenderType } from 'api/types/entity';

export type GenderApi =
  | GenderApi1
  | GenderApi2
  | GenderApi3
  | GenderApi4
  | GenderApi5;

const genderMap: Record<GenderApi, ClientGenderType> = {
  [GenderApi1.Male]: ClientGenderType.Male,
  [GenderApi1.Female]: ClientGenderType.Female,
};

export const parseClientGenderType = (gender: GenderApi) => genderMap[gender];
